import React from 'react'
import {translate} from 'react-i18next'
import {ChangeEmailView, ChangeEmailText, ChangeEmailButton} from './ChangeEmailStyles'

const ChangeEmail = ({t, value, onChange, readOnly}) => (
  <ChangeEmailView>
    <ChangeEmailText>{value}</ChangeEmailText>
    {!readOnly && (
      <ChangeEmailButton onClick={onChange} type="button">
        {t('buttons.change-email')}
      </ChangeEmailButton>
    )}
  </ChangeEmailView>
)

export default translate()(ChangeEmail)
